export default "__VITE_ASSET__CsVSKqk6__"